import { FC } from 'react'

import PopUpRow from './pop-up-row'

import { ISafetyCase } from '../../interfaces'

import s from './map-popups.module.scss'

type SafetyCasePopUpContentProps = {
  safetyCase?: ISafetyCase
}

const SafetyCasePopUpContent: FC<SafetyCasePopUpContentProps> = props => {
  const { safetyCase } = props

  return (
    <div className={s['safety-case-content']}>
      <PopUpRow label="Name" value={safetyCase?.name || ''} />

      <PopUpRow label="Status" value={safetyCase?.parentStatus?.name || ''} />

      <PopUpRow label="Location" value={safetyCase?.location?.name || 'Adhoc'} />
    </div>
  )
}

export default SafetyCasePopUpContent
